import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateEventContact($companyId: ID!, $id: ID!, $attributes: EventContactAttributes!) {
    updateEventContact(companyId: $companyId, id: $id, attributes: $attributes) {
      eventContact {
        id
        ...UpdatedEventContact
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedEventContact on EventContact {
    id
    name
    email
    phone
    color
    contactType
    user { id displayName email }
    event { id }
  }
`
